export default __webpack_public_path__ + "static/media/searchRTIcon.40e62394.webp";